import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const ExamGroupService = sdk.getService('ExamGroupService');

export const useExamGroupOptionsByCommunity = (vertical: string) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['exam-groups', 'by-vertical', vertical],
    queryFn: () => ExamGroupService.getExamGroupsByVertical(vertical)
  });
  return { data, isLoading, error };
};
